import { useState } from "react";
import ToolWrapper from "../../PowerPack_Common/ToolWrapper";
import { sticky_colors } from "../Series/Series_List_Data";


const miro = window.miro;
const { board } = miro;

const stickiesPerPackMin = 2;
const stickiesPerPackMax = 100;
const packsMin = 1;
const packsMax = 20;
const packSeparationPercent = .2;

const toolConfig = {
  tool_name: "Sticky Packs",
  tool_icon: "icon-sticky-bulk",
  tool_short_description: "Make ready-to-grab kits of stickies for workshops.",
  tool_id: "",
  works_on: "many to one",
  valid_step_1_item_types: ["sticky"],

  tool_type_icons: (
    <div className="cs5 ce12 grid">
      <div className="cs1 m2 icon icon-sticky-bulk"></div>
    </div>
  ),
  tool_is_in_uat: true,
  tool_is_pro: false,
};

export default function StickyPacks({
  userIsPro,
  environment,
}) {
  const [stickiesPerPack, setStickiesPerPack] = useState(2);
  const [numberOfPacks, setPacks] = useState(1);

  async function createStickyPacks() {
    const viewport = await board.viewport.get();
    const stickyWidth = viewport.width * 0.1
    const stickyShift = stickyWidth * .1
    const packShift = stickyWidth + (stickyWidth * packSeparationPercent) + (stickyShift * (stickiesPerPack - 1));
    const startX = viewport.x + viewport.width / 2
    const startY = viewport.y + viewport.height / 2

    // loop through the nuber of packs
    for (let packIndex = 0; packIndex < numberOfPacks; packIndex++) {

      // loop through the number of stickies per pack
      for (let stickyIndex = 0; stickyIndex < stickiesPerPack; stickyIndex++) {

        // Create the stickie
        await board.createStickyNote({
          width: stickyWidth,
          x: startX + (stickyIndex * stickyShift) + (packIndex * packShift),
          y: startY + (stickyIndex * stickyShift),
          style: {
            // fill with random color
            fillColor: sticky_colors[Math.floor(Math.random() * sticky_colors.length)]
          }
        })

      }

    }
  }

  return (
    <ToolWrapper
      toolConfig={toolConfig}
      userIsPro={userIsPro}
      environment={environment}>


      <div className="cs1 ce12 p-medium mt-0">
        {toolConfig.tool_short_description}
      </div>

      <div className="cs1 ce12 grid slidecontainer mt-8">
        <input
          name="stickies_per_pack_form_input"
          type="number"
          className="cs1 ce3 input input-small ml-2"
          placeholder="2"
          min={stickiesPerPackMin}
          max={stickiesPerPackMax}
          value={stickiesPerPack}
          onChange={(e) => setStickiesPerPack(e.target.value)}
        />
        <div className="cs4 ce12 grid mb-0">
          <p className="cs1 ce12 p-medium mb-4 mt--4">Stickies Per Pack</p>
          <input
            type="range"
            min={stickiesPerPackMin}
            max={stickiesPerPackMax}
            value={stickiesPerPack}
            className="slider cs1 ce5 mt--6"
            onChange={(e) => {
              setStickiesPerPack(e.target.value);
            }}
            id="stickies_per_pack_slider"
          />
        </div>
      </div>

      <div className="cs1 ce12 grid slidecontainer mt-8">
        <input
          name="packs_form_input"
          type="number"
          className="cs1 ce3 input input-small ml-2"
          placeholder="2"
          min={packsMin}
          max={packsMax}
          value={numberOfPacks}
          onChange={(e) => setPacks(e.target.value)}
        />
        <div className="cs4 ce12 grid mb-0">
          <p className="cs1 ce12 p-medium mb-4 mt--4">Packs</p>
          <input
            type="range"
            min={packsMin}
            max={packsMax}
            value={numberOfPacks}
            className="slider cs1 ce5 mt--6"
            onChange={(e) => {
              setPacks(e.target.value);
            }}
            id="packs_slider"
          />
        </div>
      </div>

      <div className="cs1 ce12 grid mb-0">
        <button
          type="button"
          className="button button-primary button-small cs1 ce12 mb-0 mt-0"
          onClick={createStickyPacks}>
          Create Sticky Packs
        </button>
      </div>

    </ToolWrapper>
  );
}
